<template>
  <Login v-if="!isAuthenticated" />  <!-- Zeige Login an, falls nicht eingeloggt -->
  <div v-else class="content" :data-theme="theme">
    <div v-show="showMenu" class="filterSide">
      <Filter />
    </div>
      <div class="main-content">
        <Header @closeMenu="showMenu = false" @showMenu="showMenu = true"/>
        <TabHandler v-if="view !== 'FS'"/> 
        <div class="previewContent" v-if="view !== 'Preview'">
          <Preview v-if="view === 'Edit'" :emailData="emailData" />
          <Template v-if="view === 'HTML'" />
          <Rulesets v-if="view === 'Rulesets'" />
          <JsonTemplate v-if="view === 'JSON'" />
          <XmlMapping v-if="view === 'Mapping'" />
          <FileSystem v-if="view === 'FS'" />
        </div>
        <div class="previewControll"  v-if="view == 'Preview'">
          <PreviewControll/>   
        </div>
      </div>
      <div class="sidebarSide">
        <Sidebar />
      </div>
  </div>
  </template>
  <script>
import { mapState } from 'vuex';
import { ref, onMounted, onUnmounted } from 'vue';
import Filter from './components/FilterNew.vue';
import Sidebar from './components/Sidebar.vue';
import Preview from './components/Preview.vue';
import Template from './components/Template.vue';
import Rulesets from './components/Rulesets.vue';
import JsonTemplate from './components/JsonTemplate.vue';
import XmlMapping from './components/XmlMapping.vue';
import Header from './components/Header.vue';
import AddList from './components/Reusables/AddList.vue';
import PreviewControll from './components/preview/PreviewControll.vue';
import TabHandler from './components/TabHandler.vue';
import Login from './components/Login.vue';
import FileSystem from './components/FolderSystem/FSMain.vue'
import { logout } from './utils/db/apiService.js'; // Import der Logout-Funktion

export default {
  name: 'App',
  components: {
    Filter, Sidebar, Header, AddList, Preview, Template, JsonTemplate, PreviewControll, Rulesets, XmlMapping, TabHandler, Login, FileSystem
  },
  computed: {
    ...mapState(['view', 'viewport', 'theme', 'emailData']),
  },
  setup() {
    const isAuthenticated = ref(false);
    const showMenu = ref(true)
    let inactivityTimer;

    // Prüft, ob der User eingeloggt ist
    const checkAuth = () => {
      const token = localStorage.getItem('accessToken');
      isAuthenticated.value = !!token;
      if (isAuthenticated.value) {
        resetInactivityTimer(); // Starte den Inaktivitäts-Timer
      }
    };

    // Timer zurücksetzen bei Nutzeraktivität
    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(() => {
        logout(); // Logout nach 20 Minuten Inaktivität
      }, 20 * 60 * 1000); // 20 Minuten
    };

    // Event-Listener für Mausbewegung, Tastatur, Scrollen
    onMounted(() => {
      checkAuth(); // Direkt prüfen, ob der User eingeloggt ist
      window.addEventListener('mousemove', resetInactivityTimer);
      window.addEventListener('keydown', resetInactivityTimer);
      window.addEventListener('scroll', resetInactivityTimer);
    });

    // Event-Listener entfernen, wenn die Komponente entladen wird
    onUnmounted(() => {
      window.removeEventListener('mousemove', resetInactivityTimer);
      window.removeEventListener('keydown', resetInactivityTimer);
      window.removeEventListener('scroll', resetInactivityTimer);
      clearTimeout(inactivityTimer);
    });

    return { isAuthenticated, showMenu };
  }
};
</script>
  <style>
  body {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
  
  #app {
    font-family: 'Montserrat', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
  }
  
  .content {
    background: white;
    height: 100vh;
    display: flex;
    width: 100%;
  }
  
  .filterSide{
    flex: 0 0 14%;
    max-width: 14%;
    height: 100vh;
  }
  
  .sidebarSide {
    overflow-y: scroll ;
    flex: 0 0 18%;
    height: 100vh;
  }
  
  
  .main-content {
    flex: 1;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
  
  .header {
    flex: 0 0 auto;
  } 
  
  .previewContent {
    flex: 1 1 auto; 
    overflow-y: scroll;
         /* Adjust height according to your header height */
  }
  
  .previewControll {
    flex: 1 1 auto;
    background: linear-gradient(135deg, #05bbef 0, #005e73 70%); 
     /* Adjust height according to your header height */
  }
  
  </style>